import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Button } from "semantic-ui-react";
import { format } from "date-fns";
import { DeliveryTypes } from "utilities/dist/order/constants";
import { DateTimeFormat } from "utilities/dist/invoice/constants";

const InvoiceComponentDeliveryBlock = ({
    delivery_type,
    fulfillment_note,
    orderNotes,
    order_delivery_type,
    onChangeDeliveryType,
    onChangeFulfillmentNote,
    disabled,
}) => {
    const [showFulfillmentNoteEditor, setShowFulfillmentNoteEditor] = useState(
        !!fulfillment_note?.trim()
    );

    const hasOrderNotes = Array.isArray(orderNotes) && orderNotes.length > 0;
    const orderWasDelivery = order_delivery_type === DeliveryTypes.DELIVERY;

    const isPickup = delivery_type === DeliveryTypes.PICKUP;
    const isDelivery = delivery_type === DeliveryTypes.DELIVERY;

    const deliveryNoteRequired = isDelivery && !orderWasDelivery;
    const showFulfillmentNoteInput =
        deliveryNoteRequired || showFulfillmentNoteEditor || !!fulfillment_note?.trim();

    return (
        <Form>
            <Form.Field>
                <label>Fulfillment</label>
                <Form.Group inline>
                    <Form.Radio
                        label="Delivery"
                        name="delivery_type"
                        value={DeliveryTypes.DELIVERY}
                        checked={isDelivery}
                        onChange={(e, { value }) => onChangeDeliveryType(value)}
                        disabled={disabled}
                        data-cy="invoice_delivery_option"
                    />
                    <Form.Radio
                        label="In-Store Pick Up"
                        name="delivery_type"
                        value={DeliveryTypes.PICKUP}
                        checked={isPickup}
                        onChange={(e, { value }) => onChangeDeliveryType(value)}
                        disabled={disabled}
                        data-cy="invoice_pickup_option"
                    />
                </Form.Group>
            </Form.Field>

            {hasOrderNotes && (
                <div className="tp-10">
                    <b>Customer Notes:</b>
                    <ul style={{ marginTop: 4, marginBottom: 8, paddingLeft: 20 }}>
                        {orderNotes.map(item => (
                            <li key={item.id} className="tp-5">
                                {item.note}{" "}
                                <span className="text-secondary" style={{ fontSize: "0.9em" }}>
                                    — {format(new Date(item.created_at), DateTimeFormat)}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {showFulfillmentNoteInput ? (
                <Form.Field required={deliveryNoteRequired}>
                    <label>{isDelivery ? "Delivery note" : "Note"}</label>
                    <Form.TextArea
                        placeholder={
                            isDelivery ? "Enter your preferred delivery time..." : "Add a note..."
                        }
                        value={fulfillment_note}
                        onChange={(e, { value }) => onChangeFulfillmentNote(value ?? "")}
                        disabled={disabled}
                        rows={2}
                        data-cy="invoice_fulfillment_note"
                    />
                    {!deliveryNoteRequired && (
                        <Button
                            type="button"
                            size="small"
                            basic
                            negative
                            content="Cancel"
                            className="tp-5"
                            onClick={() => {
                                onChangeFulfillmentNote("");
                                setShowFulfillmentNoteEditor(false);
                            }}
                            disabled={disabled}
                            data-cy="invoice_fulfillment_note_cancel"
                        />
                    )}
                </Form.Field>
            ) : (
                <div className="tp-10">
                    <Button
                        type="button"
                        size="small"
                        primary
                        content="Add note"
                        icon="plus"
                        onClick={() => setShowFulfillmentNoteEditor(true)}
                        disabled={disabled}
                        data-cy="invoice_add_fulfillment_note"
                    />
                </div>
            )}
        </Form>
    );
};

InvoiceComponentDeliveryBlock.propTypes = {
    delivery_type: PropTypes.string.isRequired,
    fulfillment_note: PropTypes.string.isRequired,
    onChangeDeliveryType: PropTypes.func.isRequired,
    onChangeFulfillmentNote: PropTypes.func.isRequired,
    orderNotes: PropTypes.array,
    order_delivery_type: PropTypes.string,
    disabled: PropTypes.bool,
};

InvoiceComponentDeliveryBlock.defaultProps = {
    orderNotes: [],
    order_delivery_type: null,
    disabled: false,
};

export default InvoiceComponentDeliveryBlock;
